/* Static design content (copy + icon mapping). Dynamic data (forms, handbook,
   documents, policies, children, submissions) is fetched from the backend. */

export const NAV = [
  { id: "dashboard", label: "Dashboard", icon: "home" },
  { id: "handbook", label: "Handbook", icon: "book" },
  { id: "forms", label: "Forms", icon: "forms" },
  { id: "policies", label: "Policies", icon: "shield" },
  { id: "account", label: "Account", icon: "user" },
];

export const QUICK_CARDS = [
  { id: "handbook", icon: "book", title: "Parent Handbook", desc: "Everything about your child's days at Stride — policies, routines and what to pack." },
  { id: "forms", icon: "forms", title: "Forms & Requests", desc: "Notify a holiday, a sick day, or request a change to your booking." },
  { id: "policies", icon: "shield", title: "Policies", desc: "Our centre policies and fact sheets, all in one place." },
  { id: "account", icon: "user", title: "Your Account", desc: "Update your details and view your children." },
];

/* Map a form code to its icon and the action label shown on the submit button. */
export const FORM_ICONS = {
  holiday: "sun",
  sick: "heart",
  change: "swap",
  end: "logout",
  refund: "refresh",
  refer: "gift",
};

export const FORM_ACTION = {
  refer: "Send referral",
};

/* Per-form right-rail helper content (design copy). */
export const FORM_ASIDE = {
  holiday: {
    title: "How the discount works",
    rules: [
      "Notified holidays taken with at least 14 days' notice receive a 50% gap-fee discount.",
      "A maximum of 4 weeks' discounted holiday applies per child each calendar year.",
      "Child Care Subsidy continues to apply for up to 42 absence days per child, per year.",
    ],
    link: "Read the Holiday Fees Policy",
    showBalance: true,
  },
  sick: {
    title: "Good to know",
    rules: [
      "Replacement days are within the same week and subject to availability.",
      "Your centre will confirm the replacement day with you.",
    ],
  },
  change: {
    title: "How changes work",
    rules: [
      "Add, drop or move regular days from this request.",
      "Changes are confirmed by your centre director before they take effect.",
    ],
  },
  end: {
    title: "Ending your booking",
    rules: [
      "Four weeks' notice applies as per your enrolment agreement.",
      "Your final day is confirmed by your centre.",
    ],
  },
  refund: {
    title: "About refunds",
    rules: [
      "Refunds apply to a credit balance on your family account.",
      "Processed within 10 business days to your nominated account.",
    ],
  },
  refer: {
    title: "Refer a friend",
    rules: [
      "Tell us who'd love Stride and we'll reach out warmly.",
      "You'll both enjoy a thank-you on your account when they enrol.",
    ],
  },
};

/* Default notification preferences (front-end only for v1). */
export const NOTIFICATIONS = [
  { id: "updates", title: "Daily updates", desc: "Photos, meals, sleeps and learning moments from your child's day.", email: true, sms: true },
  { id: "forms", title: "Form confirmations", desc: "When your centre actions a form you've sent — holidays, changes, refunds.", email: true, sms: true },
  { id: "account", title: "Account & fees", desc: "Statements, payment reminders and changes to your account.", email: true, sms: true },
  { id: "centre", title: "Centre news", desc: "Closures, events, and news from your centre.", email: true, sms: true },
  { id: "marketing", title: "Stride newsletter", desc: "Occasional parenting tips and stories from across Stride.", email: true, sms: true },
];

export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri"];

export function greeting() {
  const h = new Date().getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}
